import { useQuery } from '@tanstack/react-query';
import MapPortalService from '../services/MapPortal/mapportal.service';

const useFetchAllMaps = () => {
  const { getAllMaps } = MapPortalService();
  const { data: response = [], isLoading: loading } = useQuery(getAllMaps());

  return {
    data: response,
    isLoading: loading,
  };
};

export default useFetchAllMaps;
